import {h, Fragment} from "preact"
import { useFacets, useProductFilters, useSelectedFiltersCount, useActions } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Icon from "./elements/Icon"
import { useEffect } from "preact/hooks"

function ToggleSidebarButton({ className }) {
    return (
        <label for="toggle-mobile-sidebar" class="ns-d-block ns-d-l-none">
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16 12a2.5 2.5 0 1 0-2.421-3.125H6.625a.625.625 0 1 0 0 1.25h6.954A2.501 2.501 0 0 0 16 12zm-1.25-2.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0zM6 14.5a2.5 2.5 0 0 1 4.921-.625h6.954a.625.625 0 1 1 0 1.25h-6.954A2.501 2.501 0 0 1 6 14.5zm3.75 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z" fill="currentColor"></path>
            </svg>
        </label>
    )
}

function CloseButton(){
    return (
        <label class="ns-sidebar-close" for="toggle-mobile-sidebar">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <path d="M6.99969 7L19.4795 19.4798" stroke="#282D3A" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M6.99969 19.4798L19.4795 7" stroke="#282D3A" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
        </label>
    )
}

export default function SideBar({ toggleId, openedSidebar, setOpenedSidebar }) {
    const { loading, facets } = useFacets()
    const { filters, removeAll } = useProductFilters()
    const { toggleProductFilter } = useActions();
    const selectedFiltersCount = useSelectedFiltersCount()

    const lengthFilter = facets?.find(v => v.field === 'extra.torso-length')
    const classicCount = lengthFilter?.data?.find(d => d.value == "classic")?.count
    useEffect(() => {
        setTimeout(() => {
            if (!loading && lengthFilter && classicCount > 5) {
                toggleProductFilter('extra.torso-length', 'classic', true)
            }
        }, 250)
    }, [])

    return facets?.length > 0 ? (
        <>
        <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class={`ns-sidebar-wrapper ns-d-none ${openedSidebar ? 'ns-d-l-block' : ''} ns-h-100 col-span-3 hidden lg:block`}
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content sticky  overflow-auto">
                    <div class="ns-sidebar-header py-6 border-b border-secondary-color-1-10 ns-d-none ns-d-l-block">
                        <div class="flex items-center">
                            <ToggleSidebarButton />
                            <span class="ns-d-none ns-d-l-block" onClick={() => setOpenedSidebar(!openedSidebar)}>
                                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 12a2.5 2.5 0 1 0-2.421-3.125H6.625a.625.625 0 1 0 0 1.25h6.954A2.501 2.501 0 0 0 16 12zm-1.25-2.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0zM6 14.5a2.5 2.5 0 0 1 4.921-.625h6.954a.625.625 0 1 1 0 1.25h-6.954A2.501 2.501 0 0 1 6 14.5zm3.75 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <p class="circularmedium--desktop-body text-secondary-color-1 ml-[9.5px]">Filter By</p>
                            {filters.length > 0 && <span class="ns-clear-all" style="margin-left: auto" onClick={() => { removeAll() }}>Clear All</span>}
                        </div>
                    </div>
                    <div class="ns-sidebar-header ns-sidebar-header-mobile py-6 border-b border-secondary-color-1-10 ns-d-block ns-d-l-none ns-relative">
                        <div class="flex items-center">
                            <ToggleSidebarButton />
                            <p class="circularmedium--desktop-body text-secondary-color-1 ml-[9.5px]">Filter</p>
                            {filters.length > 0 && <span class="ns-clear-all" onClick={() => { removeAll() }}>Clear All</span>}
                            <CloseButton />
                        </div>
                        <SelectedFilters />
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-sidebar-footer ns-d-l-none ns-d-flex ns-w-100">
                        <button class="ns-sidebar-submit ns-d-flex" onClick={(e) => e.target.closest(".ns-sidebar-wrapper").querySelector(".ns-sidebar-header-mobile .ns-sidebar-close")?.click()}>APPLY</button>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
